module.exports = __webpack_public_path__ + "static/media/tomo.16901f00.svg";